<template>
  <div class="banner">
    <img
      v-bind:src="require(`../assets/image/${image}`)"
      v-bind:alt="alt"
      class="banner__image"
    />
  </div>
</template>

<script>
export default {
  name: 'Banner',
  props: {
    image: String,
    alt: String,
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  @import "@/assets/scss/settings.scss";

  $banner-height-s: 200px;
  $banner-height: 300px;

  .banner {
    overflow: hidden;
    height: $banner-height-s;

    @include small-up {
      width: 100%;
      height: auto;
    }
  }

  .banner__image {
    width: auto;
    height: 100%;
    margin-left: -50%;

    @include small-up {
      width: 100%;
      height: auto;
      margin-left: 0;
    }
  }
</style>
